// extracted by mini-css-extract-plugin
export default {"multipleActions":"MultipleActions_multipleActions__02oeg","button":"MultipleActions_button__Ql79E"};